
import React from "react";
import oruclicksLogo from "../../../Assets/images/oruclicks-logo.svg";

// OruClick logo component (SVG asset)
const CLogo = ({
  size = "45px",
  textSize = "20px",
  subtitle = "Career",
  showText = true,
  iconOnly = false,
  isDarkTheme = false,
  onClick,
  className,
  style
}) => {
  const resolvedSize = typeof size === "number" ? `${size}px` : size;
  const resolvedTextSize = typeof textSize === "number" ? `${textSize}px` : textSize;
  const resolvedTopSize = typeof textSize === "number" ? `${Math.round(textSize * 0.55)}px` : `calc(${resolvedTextSize} * 0.55)`;

  return (
    <div
      onClick={onClick}
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "10px",
        cursor: onClick ? "pointer" : "default",
        ...style
      }}
    >
      <img
        src={oruclicksLogo}
        alt="OruClick Logo"
        width={resolvedSize}
        height={resolvedSize}
        style={{
          display: "block",
          filter: isDarkTheme ? "brightness(1.15)" : "none"
        }}
      />
      {!iconOnly && showText && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            lineHeight: 1.15,
            fontFamily: "Manrope, Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
            textRendering: "optimizeLegibility"
          }}
        >
          <span
            style={{
              fontSize: resolvedTopSize,
              fontWeight: 500,
              letterSpacing: "0.3px",
              color: isDarkTheme ? "#C5D1FF" : "#6B7280"
            }}
          >
            OruClick
          </span>
          <span
            style={{
              fontSize: resolvedTextSize,
              fontWeight: 700,
              letterSpacing: "0.2px",
              color: isDarkTheme ? "#FFFFFF" : "#111111"
            }}
          >
            {subtitle}
          </span>
        </div>
      )}
    </div>
  );
};

export default CLogo;
